import { MoreVertical, Trash2 } from "lucide-react";
import cn from "@/lib/cn";
import { useState } from "react";
import { PaymentCard } from "@/features/payment/types";
import { CardView } from "@/features/payment/components/CardView";

interface CardOnFileRowProps {
  card: PaymentCard;
  patientName: string;
  onDelete: () => void;
}

export function CardOnFileRow({
  card,
  patientName,
  onDelete,
}: CardOnFileRowProps) {
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <div className="mb-4 flex items-center gap-3.5 rounded-[14px] border border-[#EBEDF2] bg-white px-5 py-4 shadow-[0_1px_3px_rgba(0,0,0,0.04)]">
      <CardView card={card} fallbackName={patientName} />

      <div className="relative shrink-0">
        <button
          type="button"
          aria-label={`Open card actions for ${patientName}`}
          onClick={() => setMenuOpen(!menuOpen)}
          className={cn(
            "flex size-8 cursor-pointer items-center justify-center rounded-lg border-0 transition-colors duration-150",
            menuOpen ? "bg-[#F3F4F6]" : "bg-transparent hover:bg-[#F3F4F6]",
          )}
        >
          <MoreVertical className="size-4 text-[#6B7280]" strokeWidth={2} />
        </button>
        {menuOpen && (
          <div className="animate-v5-overlay-fade-in-menu absolute top-9 right-0 z-10 min-w-40 overflow-hidden rounded-[10px] border border-[#EBEDF2] bg-white shadow-[0_4px_16px_rgba(0,0,0,0.1)]">
            <button
              type="button"
              onClick={() => {
                setMenuOpen(false);
                onDelete();
              }}
              className="flex w-full cursor-pointer items-center gap-2 border-0 bg-transparent px-3.5 py-2.5 text-[13px] font-semibold text-[#DC2626] transition-colors duration-100 hover:bg-[#FEF2F2]"
            >
              <Trash2 className="size-3.5" strokeWidth={2} />
              Delete Card
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
